<template>
  <div>
    <div class="max-resolution">
      <div class="spinner" v-show="spinnerOn"></div>
      <div class="container mb-5">
        <div class="row mt-5">
          <div class="col-sm-7">
            <div class="rg-head-width">
              <h2 class="register-page-heading">
                Use Conversational AI to give the best experience to your
                Customers
              </h2>
              <h5 class="hc-subhead">
                Lets get started by building a smart Bot that would enhance your
                customer experience
              </h5>
              <div class="tr-pd">Trial Period - 30 days</div>
            </div>
          </div>
          <div class="col-sm-5 order-first order-sm-last">
            <img :src="require('@/assets/img/Group 2287.svg')" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="blue-bg">
      <div class="max-resolution">
        <div class="container mb-5">
          <div class="row pt-5">
            <div class="col-sm-7">
              <h2 class="register-page-heading text-center">SIGN UP</h2>
              <div>
                <form @submit.prevent="save_data">
                  <!-- <div class="col-sm-12 mb-3">
                    <div class="radio">
                      <label>
                        <input
                          type="radio"
                          @change="toggle_domain"
                          value="Customer"
                          v-model="user.registration_type"
                        />
                        <span class="icn"></span> Customer
                      </label>
                      <label>
                        <input
                          type="radio"
                          @change="toggle_domain"
                          value="Partner"
                          :disabled="input_disable"
                          v-model="user.registration_type"
                        />
                        <span class="icn"></span> Partner
                      </label>
                    </div>
                  </div> -->
                  <div class="custom-display-flex">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control company"
                          id="exampleFormControlInput1"
                          placeholder="First Name"
                          required
                          v-model="user.first_name"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control company"
                          placeholder="Last Name"
                          required
                          v-model="user.last_name"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="custom-display-flex">
                    <div :class="(user.registration_type === 'Partner') ? 'col-sm-12' : 'col-sm-6'">
                      <div class="form-group">
                        <input
                          id="CompanyName"
                          type="text"
                          v-model.trim="user.company_name"
                          class="form-control company"
                          placeholder="Company Name"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-sm-6" v-if="user.registration_type === 'Customer'">
                      <div class="form-group" id="domain_input">
                        <select
                          v-model="user.domain"
                          class="form-control domain custom-select"
                          id="select_domain_input"
                          required
                        >
                          <option value disabled>Select Domain</option>
                          <option
                            :value="company_name.value"
                            v-for="company_name in companies"
                            :key="company_name.option"
                          >
                            {{ company_name.option }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <input
                        id="HostName"
                        type="text"
                        v-model.trim="user.host_name"
                        class="form-control key"
                        placeholder="Your Website Name (eg. https://cense.ai)"
                        required
                        @input="check_host"
                      />
                    </div>
                    <div
                      v-show="
                        show_host_validation === true && user.host_name != ''
                      "
                    >
                      <p class="is-invalid">
                        Please enter a proper Website Name (eg. https://cense.ai)
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <input
                        id="email"
                        type="email"
                        @input="check_email"
                        v-model.trim="user.email"
                        class="form-control email"
                        placeholder="Email Address"
                        required
                      />
                    </div>
                    <div
                      v-show="
                        show_email_validation === true && user.email != ''
                      "
                    >
                      <p class="is-invalid">
                        Please enter a valid email address
                      </p>
                    </div>
                  </div>
                  <div class="custom-display-flex">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control pass"
                          id="form_password"
                          placeholder="Password"
                          required
                          @input="check_value"
                          v-model.trim="user.password"
                        />
                        <a
                          href="javascript: void(0)"
                          @click="password_toggle_1"
                          class="view-pass"
                        >
                          <img :src="require('@/assets/img/eye-icn.png')" alt />
                        </a>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control pass"
                          placeholder="Confirm Password"
                          required
                          id="confirm_password"
                          v-model.trim="confirm_password"
                        />
                        <a
                          href="javascript: void(0)"
                          @click="password_toggle_2"
                          class="view-pass"
                        >
                          <img :src="require('@/assets/img/eye-icn.png')" alt />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12"></div>
                  <div class="custom-display-flex">
                    <div class="col-sm-6">
                      <div id="message">
                        <h6>Password must contain the following:</h6>
                        <p id="letter" class="invalid" style="margin-left: 10%">
                          A lower case letter
                        </p>
                        <p
                          id="capital"
                          class="invalid"
                          style="margin-left: 10%"
                        >
                          A capital (uppercase) letter
                        </p>
                        <p id="number" class="invalid" style="margin-left: 10%">
                          A number
                        </p>
                        <p
                          id="special"
                          class="invalid"
                          style="margin-left: 10%"
                        >
                          A special character
                        </p>
                        <p id="length" class="invalid" style="margin-left: 10%">
                          Minimum 8 characters
                        </p>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div id="validConfirm">
                        <p
                          class="is-invalid"
                          style="color: red"
                          v-if="
                            validConfirmPassword != true &&
                            confirm_password != '' &&
                            validPassword == true
                          "
                        >
                          {{ validConfirmPassword }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div></div>
                  <div class="col-sm-12">
                    <p>
                      Cense.ai uses the contact information you provide to us to
                      contact you about our products and services. You may
                      unsubscribe from these communications at anytime. For more
                      information check out our <a href="javascript: void(0)" @click="$router.push('/privacy-policy')"> privacy policy </a>
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <button
                      class="darkblue-btn-analytics"
                      style="margin: 1rem 0rem 1rem"
                      type="submit"
                    >
                      SIGN UP
                    </button>
                  </div>
                  <div class="col-sm-12">
                    <p>
                      Once your information is submitted, you will receive an email with a verification link. 
                    </p>
                    <!-- <p>
                      10 days later, you’ll get a link to test your new virtual
                      agent, on your terms, for 30 days.
                    </p> -->
                  </div>
                </form>
              </div>
            </div>
            <div class="col-sm-5 order-first order-sm-last">
              <img
                :src="require('@/assets/img/RegisterPageGraphic.svg')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
export default {
  name: "Register",
  data() {
    return {
      user: {
        company_name: "",
        email: "",
        password: "",
        domain: "",
        services: "",
        host_name: "",
        registration_type: "Customer",
        license_key:
          Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15),
        referral_id: "null",
        subscription: "",
        date: "",
        first_name: "",
        last_name: "",
      },
      companies: [],
      confirm_password: "",
      input_disable: false,
      letter: document.getElementById("letter"),
      capital: document.getElementById("capital"),
      number: document.getElementById("number"),
      special: document.getElementById("special"),
      array: [],
      reg_pwd: /^(?!.*\\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@!%*?&$^()+~|'{}:;.?~_+=<>/-])[A-Za-z\d#@!%*?&$^()+~|'{}:;.?~_+=<>/-]{8,}/,
      reg_email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      reg_host: /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i,
      show_email_validation: false,
      show_host_validation: false,
      spinnerOn: false,
    };
  },
  computed: {
    validEmail() {
      if (this.reg_email.test(this.user.email)) {
        return true;
      } else {
        return false;
      }
    },
    valid_cname() {
      if (this.user.company_name != "") {
        return true;
      } else {
        return false;
      }
    },
    validPassword() {
      if (this.reg_pwd.test(this.user.password)) {
        return true;
      } else {
        return "Password must contain minimum 8 characters, atleast 1 UpperCase Alphabet, 1 LowerCase Alphabet, 1 Number and 1 Special Character";
      }
    },
    validConfirmPassword() {
      if (this.confirm_password == this.user.password) {
        return true;
      } else {
        return "Passwords do not match";
      }
    },
    validHost() {
      if (this.reg_host.test(this.user.host_name)) {
        this.show_host_validation = false;
        return true;
      } else {
        this.show_host_validation = true;
        return false;
      }
    },
    // service_types() {
    //   if (this.chatbot_check && this.voice_system_check) {
    //     (this.user.services = "Chatbot"), "Voice System";
    //   } else if (this.chatbot_check) {
    //     this.user.services = "Chatbot";
    //   } else if (this.voice_system_check) {
    //     this.user.services = "Voice System";
    //   } else {
    //     this.user.services = "";
    //   }
    // }
  },
  mounted() {
    this.$CensePortalHttp
      .get("user/portal/get-domain-list")
      .then((response) => {
        this.companies = [];
        for (var i in response.data) {
          if (response.data[i].value == "Retail" || response.data[i].value == "Other"){
            this.companies.push(response.data[i]);
          }
        }
      });
  },
  methods: {
    toggle_domain(event) {
      this.user.domain = "";
      // if (event.target.value == "Customer") {
      //   document.getElementById("domain_input").style.display = "";
      // } else if (event.target.value == "Partner") {
      //   document.getElementById("domain_input").style.display = "none";
      // }
    },
    password_toggle_1() {
      var password = document.getElementById("form_password");
      if (password.type == "text") {
        password.type = "password";
      } else if (password.type == "password") {
        password.type = "text";
      }
    },
    password_toggle_2() {
      var password = document.getElementById("confirm_password");
      if (password.type == "text") {
        password.type = "password";
      } else if (password.type == "password") {
        password.type = "text";
      }
    },
    check_value() {
      var letter = document.getElementById("letter");
      var capital = document.getElementById("capital");
      var number = document.getElementById("number");
      var special = document.getElementById("special");
      if (this.user.password != "") {
        document.getElementById("message").style.display = "block";
      } else {
        document.getElementById("message").style.display = "none";
      }
      var lowerCaseLetters = /[a-z]/g;
      if (this.user.password.match(lowerCaseLetters)) {
        letter.classList.remove("invalid");
        letter.classList.add("valid");
        this.array[0] = 1;
      } else {
        letter.classList.remove("valid");
        letter.classList.add("invalid");
        this.array[0] = 0;
      }

      // Validate capital letters
      var upperCaseLetters = /[A-Z]/g;
      if (this.user.password.match(upperCaseLetters)) {
        capital.classList.remove("invalid");
        capital.classList.add("valid");
        this.array[1] = 1;
      } else {
        capital.classList.remove("valid");
        capital.classList.add("invalid");
        this.array[1] = 0;
      }

      // Validate numbers
      var numbers = /[0-9]/g;
      if (this.user.password.match(numbers)) {
        number.classList.remove("invalid");
        number.classList.add("valid");
        this.array[2] = 1;
      } else {
        number.classList.remove("valid");
        number.classList.add("invalid");
        this.array[2] = 0;
      }

      // Special Character
      var specials = /[#@!%*?&$]/g;
      if (this.user.password.match(specials)) {
        special.classList.remove("invalid");
        special.classList.add("valid");
        this.array[3] = 1;
      } else {
        special.classList.remove("valid");
        special.classList.add("invalid");
        this.array[3] = 0;
      }
      // Validate length
      var length = null;
      if (this.user.password.length >= 8) {
        length = document.getElementById("length");
        length.classList.remove("invalid");
        length.classList.add("valid");
        this.array[4] = 1;
      } else {
        length = document.getElementById("length");
        length.classList.remove("valid");
        length.classList.add("invalid");
        this.array[4] = 0;
      }
      var sum =
        this.array[0] +
        this.array[1] +
        this.array[2] +
        this.array[3] +
        this.array[4];
      if (sum == 5 || sum == 0) {
        document.getElementById("message").style.display = "none";
      } else {
        document.getElementById("message").style.display = "block";
      }
    },
    check_email() {
      if (this.reg_email.test(this.user.email)) {
        this.show_email_validation = false;
        return true;
      } else {
        this.show_email_validation = true;
        return false;
      }
    },
    check_host() {
      if (this.reg_host.test(this.user.host_name)) {
        this.show_host_validation = false;
      } else {
        this.show_host_validation = true;
      }
    },
    save_data() {
      if (
        this.validEmail &&
        this.validPassword == true &&
        this.valid_cname &&
        this.user.registration_type != null &&
        this.validHost == true &&
        this.validConfirmPassword == true
      ) {
        this.call_api();
      } else if (!this.valid_cname) {
        this.$swal.fire({
          icon: "error",
          position: "top-right",
          text: "Company Name is required",
          showConfirmButton: false,
          timer: 2000,
          toast: true,
          background: "#eac0c0",
          position: "top-right",
        });
      } else if (!this.validEmail) {
        this.$swal.fire({
          icon: "error",
          text: "Please enter a valid email",
          showConfirmButton: false,
          timer: 2000,
          toast: true,
          position: "top-right",
          background: "#eac0c0",
        });
      } else if (this.user.password == "") {
        this.$swal.fire({
          icon: "error",
          text: "Password field is blank",
          showConfirmButton: false,
          timer: 2000,
          toast: true,
          background: "#eac0c0",
          position: "top-right",
        });
      } else if (this.validPassword != true) {
        this.$swal.fire({
          icon: "error",
          text: "Please Enter a Valid Password!",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          background: "#eac0c0",
          position: "top-right",
        });
      } else if (this.user.registration_type == null) {
        this.$swal.fire({
          icon: "error",
          text: "Please select the type of registration",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          background: "#eac0c0",
          position: "top-right",
        });
      } else if (!this.validHost) {
        this.$swal.fire({
          icon: "error",
          position: "top-right",
          text: "Please Enter a proper Website Name",
          showConfirmButton: false,
          timer: 2000,
          toast: true,
          background: "#eac0c0",
        });
      } else if (this.validConfirmPassword !== true) {
        this.$swal.fire({
          icon: "error",
          position: "top-right",
          text: "Both Passwords Don't Match",
          showConfirmButton: false,
          timer: 2000,
          toast: true,
          background: "#eac0c0",
        });
      }
    },
    call_api() {
      var link = window.location.search;
      this.user.subscription =
        link.replace("?subscription=", "") == ""
          ? null
          : link.replace("?subscription=", "");
      this.spinnerOn = true;
      var d = new Date();
      this.user.date = d;
      this.$CensePortalHttp
        .post("user/portal/register", this.user)
        .then((response) => {
          this.spinnerOn = false;
          if (response.data == "Registration Successful") {
            this.$swal.fire({
              text:
                "Account created successfully!! Kindly check your e-mail for account validation",
              icon: "success",
              timer: 3000,
            });
          } else if (response.data.includes("This email is a duplicate.")) {
            this.$swal.fire({
              icon: "error",
              text:
                "This Email is already registered. Please try with another email",
              timer: 3000,
            });
          } else if (response.data.includes("Registration Unsuccessful")) {
            this.$swal.fire({
              icon: "error",
              text: "Your registration was unsuccessful. Please try again.",
              timer: 2500,
            });
          } else if (response.data == "Internal Server Error") {
            this.$swal.fire({
              icon: "error",
              text: "There was an internal server error. Please try again.",
              timer: 2500,
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: "Cannot register your account",
              showConfirmButton: false,
              timer: 2000,
            });
          }
          this.user.email = "";
          this.user.company_name = "";
          this.user.password = "";
          this.user.domain = "";
          this.host_name = "";
          this.confirm_password = "";
          this.user.first_name = "";
          this.user.last_name = "";
        })
        .catch(() => {
          this.spinnerOn = false;
          this.$swal.fire({
            icon: "error",
            text: "Some Error Occurred. Please Try Again",
            timer: 3000,
          });
        });
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .tr-pd {
    width: 100% !important;
  }
  .rg-head-width {
    width: 100% !important;
  }
}
.rg-head-width {
  width: 80%;
}
.register-page-heading {
  font-size: 2.1rem;
  font-family: "RubikMedium";
  text-transform: uppercase;
  color: #283677;
}
.hc-subhead {
  color: #3a3a3a;
  font: normal normal normal 19px/30px Rubik;
}
.tr-pd {
  width: 60%;
  background: #f9fbff 0% 0% no-repeat padding-box;
  border: 1px solid #283677;
  opacity: 1;
  font-size: 1.52rem;
  font-family: "RubikMedium";
  letter-spacing: 0px;
  color: #283677;
  text-align: center;
  padding: 0.5rem;
}
.blue-bg {
  background: rgba(236, 243, 255, 0.3) 0% 0% no-repeat padding-box;
}
#message {
  display: none;
  color: #000;
  position: relative;
  padding: 20px;
  margin-top: 10px;
}

#validConfirm {
  position: relative;
  padding: 20px;
  margin-top: 10px;
}

.valid {
  color: green;
}

.valid:before {
  position: relative;
  left: -35px;
  content: "✔";
}

/* Add a red text color and an "x" when the requirements are wrong */
.invalid {
  color: red;
}

.invalid:before {
  position: relative;
  left: -35px;
  content: "✖";
}
.is-invalid {
  color: red;
}
.is-invalid:before {
  position: relative;
  content: "✖";
}
</style>
